var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-4 mr-4",attrs:{"outlined":"","rounded":""}},[_c('v-card-text',[_c('p',{staticClass:"text-h6 text--primary mb-12"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('VueApexCharts',{attrs:{"type":"donut","options":_vm.memberNumbers.options,"series":_vm.memberNumbers.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }